import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loader from '../Components/Loader';
import Home from "../views/Home";

// Importación Lazy de las otras páginas
const LazyInscription = React.lazy(() => import("../views/Inscripcion"));
const LazyNovedades = React.lazy(() => import("../views/Novedades"));
const LazyNoticias = React.lazy(() => import("../views/Noticias"));

function WebRoutes() {
    return (
        <BrowserRouter basename="/km0">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route
                    path="inscripcion"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LazyInscription />
                        </React.Suspense>
                    }
                />
                <Route
                    path="novedades"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LazyNovedades />
                        </React.Suspense>
                    }
                />
                <Route
                    path="noticias"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LazyNoticias />
                        </React.Suspense>
                    }
                />
                <Route path="*" element={<Home />} />
            </Routes>
        </BrowserRouter>
    )
}

export default WebRoutes;
